import ApiService from './ApiService';

class OrderBookService {
  async getOrderBook(payload = {}) {
    try {
      const response = await ApiService.call('/secured/get_order_book', 'POST', payload);
      let data = response;

      return {
        orderList: data.result,
        totalCount: data.totalCount,
        page: data.offset,
        size: data.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async getOrderBookHistory(payload = {}) {
    try {
      const response = await ApiService.call('/secured/get_order_book_history', 'POST', payload);
      let data = response;

      return {
        orderList: data.result,
        totalCount: data.totalCount,
        page: data.offset,
        size: data.size,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }

  async cancelOrder(payload) {
    try {
      const response = await ApiService.call('/secured/cancel_order', 'POST', payload);
      let data = response;

      return {
        cancellationStateType: data.cancellationStateType,
        success: true,
      };
    } catch (error) {
      let data = error.response ? error.response.data : error;
      return {
        success: false,
        code: data.error || data.code,
        message: data.message,
      };
    }
  }
}
export default new OrderBookService();
